import * as CONSTS from 'redux/constants';
import * as reduxUtil from 'redux/utils/reducers';

const stateKeys = {
  page: 'page',
  verifyOtp: 'verifyOtp',
  resendOtp: 'resendOtp'
};
const initializeState = () => {
  return {
    [stateKeys.page]: reduxUtil.initializeObject(),
    [stateKeys.verifyOtp]: reduxUtil.initializeObject(),
    [stateKeys.resendOtp]: reduxUtil.initializeObject()
  };
};
const initialState = initializeState();

const reducer = (state = initialState, action) => {
  const { data, error } = action?.payload || {};

  switch (action.type) {
    case CONSTS.GET_OTP_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.page });
    case CONSTS.GET_OTP_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: stateKeys.page, data });
    case CONSTS.GET_OTP_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.page, error });
    case CONSTS.VERIFY_OTP_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.verifyOtp });
    case CONSTS.VERIFY_OTP_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: stateKeys.verifyOtp, data });
    case CONSTS.VERIFY_OTP_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.verifyOtp, error });
    case CONSTS.RESET_VERIFY_OTP_ERROR:
      return reduxUtil.updateKeyErrorState({
        state,
        key: stateKeys.verifyOtp,
        error: ''
      });
    case CONSTS.RESEND_OTP_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.resendOtp });
    case CONSTS.RESEND_OTP_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: stateKeys.resendOtp, data });
    case CONSTS.RESEND_OTP_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.resendOtp, error });
    case CONSTS.RESET_OTP_STATE:
      return initializeState();
    default:
      return state;
  }
};

export default reducer;
